module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_personal_data", [["div",{"class":"title-block no-bdr simple"},[["div",{"class":"page-width"},[["div",{"class":"title"},[["p",{},[["textNode",{"text":"Personal Data Processing"}]]]]]]]]],["div",{"class":"page-width"},[["import",{"name":"user_personal_data_rows"}],["div",{"class":"user-communication"},[["div",{"class":"title-block no-bdr simple"},[["div",{"class":"title"},[["p",{},[["textNode",{"text":"Communication"}]]]]]]],["import",{"name":"user_communications_rows"}]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/user/personal-data.tpl
// module id = 1121
// module chunks = 4